import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { Button, Typography } from "@mui/material";
import DoneIcon from "@mui/icons-material/Done";
import { useParams } from "react-router-dom";
import axiosInstance from "../../../axios/axios";
import ClearIcon from '@mui/icons-material/Clear';
import ResetPassword from "../../../pages/userManagement/Reset_Password";
import { CircularProgress } from "@mui/material";

const RegisterActivation = () => {
  const { id: resetId, token } = useParams<{ id: string; token: string }>();
  const [isEmail, setIsEmail] = useState("");
  const [isvalid_token_time, setIsvalid_token_time] = useState();
  const [isOrgUser, setIsOrgUser] = useState(false); // new
  const [apiMessage, setApiMessage] = useState<string>("");
const [authToken, setAuthToken] = useState<{
  first_name: string;
  last_name: string;
  email: string;
  valid_token_time: boolean;
} | null>(null);
const [loading, setLoading] = useState<boolean>(true);



  console.log("URL Parameters:", { resetId, token });
  // useEffect(() => {
  //   const validationResponse = async () => {
  //     try {
  //       const response = await axiosInstance.get(
  //         `/authentication/user-registration/${resetId}/${token}`
  //       );
  //       console.log(response, "response");

  //       const { valid_token_time, email } = response?.data?.data;
  //       setIsEmail(email);
  //       setIsvalid_token_time(valid_token_time);

  //       if (valid_token_time) {
  //         toast.success(response.data.message);
  //       } else {
  //         toast.error(response.data.message);
  //       }
  //     } catch (error: any) {
  //       console.error(error);
  //       toast.error(error.response?.data?.message || "Something went wrong");
  //     }
  //   };

  //   validationResponse();
  // }, []);
  useEffect(() => {
  const validationResponse = async () => {
    setLoading(true);
    try {
      const response = await axiosInstance.get(
        `/authentication/user-registration/${resetId}/${token}`
      );
      console.log(response, "response");

      const {
        valid_token_time,
        email,
        org_user,
        firstname,
        lastname,
      } = response?.data?.data;

      setIsEmail(email);
      setIsvalid_token_time(valid_token_time);

      // Capture API message
      if (response?.data?.message) {
        setApiMessage(response.data.message);
      }

      // New: Set org_user flag
      setIsOrgUser(org_user); // You’ll need to create this state if not already

      // New: Conditionally set authToken
      if (org_user) {
        setAuthToken({
          first_name: firstname,
          last_name: lastname,
          email,
          valid_token_time,
        });
      }

      // Toast based on token time
      if (!org_user && valid_token_time) {
        toast.success(response.data.message);
      } 
    } catch (error: any) {
      console.error(error);
      toast.error(error.response?.data?.message || "Something went wrong");
    }finally {
      setLoading(false); // Stop loading
    }
  };

  validationResponse();
}, [resetId, token]);

if (loading) {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "50vh",
      }}
    >
      <CircularProgress />
    </div>
  );
}



return (
  <>
    {isOrgUser && isvalid_token_time ? (
      <ResetPassword  initialAuthData={authToken || undefined}/>
    ) : isvalid_token_time ? (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          height: "50vh",
        }}
      >
        <DoneIcon sx={{ color: "green", height: "100px", width: "100px" }} />
        <Typography sx={{ mb: 1 }}>
          <strong>User Verification Is Successful.</strong>
        </Typography>

        <Typography sx={{ mb: 2 }}>{isEmail}</Typography>

        <Button
          fullWidth
          variant="contained"
          color="primary"
          className={`btn btn-primary`}
          href="/login"
        >
          Sign In
        </Button>
      </div>
    ) : (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          height: "50vh",
        }}
      >
        <ClearIcon sx={{ color: "red", height: "100px", width: "100px" }} />

        <Typography sx={{ mb: 1, textAlign: "center" }}>
          <strong>{apiMessage || "Your account Verification link has expired!"}</strong>
        </Typography>

        <Typography sx={{ mb: 2, textAlign: "center" }}>{isEmail}</Typography>
      </div>
    )}
  </>
);

};

export default RegisterActivation;
